import { render, staticRenderFns } from "./ManualUpload.vue?vue&type=template&id=bd8603d2"
import script from "./ManualUpload.vue?vue&type=script&lang=js"
export * from "./ManualUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd8603d2')) {
      api.createRecord('bd8603d2', component.options)
    } else {
      api.reload('bd8603d2', component.options)
    }
    module.hot.accept("./ManualUpload.vue?vue&type=template&id=bd8603d2", function () {
      api.rerender('bd8603d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ManualUpload.vue"
export default component.exports